import { BrowserRouter,Route,Routes } from "react-router-dom";
import Scan from './containers/App.tsx'
import Mainpage from './Mainpage';
import LoginPage from "./login_page.js";
import Appointment from "./Appointment.js"
function App(){
  return(
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Mainpage/>}/>;
      <Route path="Scan" element={<Scan/>}/>;
      <Route path="Login" element={<LoginPage/>}/>;
      <Route path="Doctors" element={<Appointment/>}/>;
      
      


      
    </Routes>
    </BrowserRouter>
  )
}
export default App;